import { baseRequestWithHeaders } from './base-request';

export const getDentalPartners = () => {
  const url = 'practice/dental-partners';
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const updateCashlessDental = (doctorId, centerId, cashlessDental) => {
  const url = 'practice/update-cashless-dental';
  const method = 'POST';
  const body = { doctorId, centerId, cashlessDental: cashlessDental ? 1 : 0 };
  return baseRequestWithHeaders(url, method, null, body);
};
